import { toast } from 'vue-sonner';

export const useToast = () => {
    return toast;
};
